import React, { useState } from 'react';
import { isValidFutureDate } from '../../utils/dateUtils';
import './CustomDatePicker.css';

const CustomDatePicker = ({ onDateSelect, onCancel, loading }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [error, setError] = useState('');

  // Get today's date in YYYY-MM-DD format for min attribute
  const today = new Date().toISOString().split('T')[0];

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    setError('');
  };

  const validateDate = (dateString) => {
    if (!dateString) {
      setError('Please select a date');
      return false;
    }

    if (!isValidFutureDate(dateString)) {
      setError('Cannot schedule for past dates');
      return false;
    }

    return true;
  };

  const handleConfirm = () => {
    if (loading) return;

    if (validateDate(selectedDate)) {
      onDateSelect(selectedDate);
    }
  };

  const handleCancel = () => {
    if (loading) return;
    setSelectedDate('');
    setError('');
    onCancel();
  };

  return (
    <div className="custom-date-picker">
      <h4>Select a custom date:</h4>
      
      <div className="date-input-section">
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          min={today}
          className="date-input"
          disabled={loading}
        />
      </div>

      {error && (
        <div className="date-error-message">
          {error}
        </div>
      )}

      <div className="date-picker-actions">
        <button
          className="cancel-button"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="confirm-button"
          onClick={handleConfirm}
          disabled={loading || !selectedDate}
        >
          {loading ? 'Scheduling...' : 'Schedule'}
        </button>
      </div>
    </div>
  );
};

export default CustomDatePicker;